// extracted by mini-css-extract-plugin
export default {"background":"Modal_background__xdZHR","fade-in":"Modal_fade-in__ayLFJ","container":"Modal_container__bivqL"};